import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FarmStatusForm from '../../../components/forms/FarmStatusForm';
import { useFarmStatusApi } from '../../../hooks/useFarmStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FarmStatusDTO } from '../../../services/apiClient';

const FarmStatusEdit: React.FC = () => {
  const { getById, edit, isLoading } = useFarmStatusApi();
  const [entityData, setEntityData] = useState<FarmStatusDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Farm Statuses', href: '/admin/farmstatuses' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching FarmStatus data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/farmstatuses');
    } catch (error) {
      console.error('Error updating FarmStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/farmstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.FarmStatus.Edit"
    >
        {entityData ? (
          <FarmStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/farmstatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default FarmStatusEdit;
